import React, { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import { getCurrentCulture } from "@utils";
import { ReactLazyImportWithGuard as lazy } from "@lib/lazy-import-with-guard";
import { useRootAppStore } from "@hooks";
import { MobilePlatform } from "@state/stores/types";

const loadFailPath = `/${getCurrentCulture()}/app-update`;
const UserMenu = lazy(
	loadFailPath,
	() => import("@components-shared/mobile/user-menu/UserMenu")
);

export default function AppUpdatedPage(props: {
	reload: () => void;
	full?: boolean;
	isNavMenuOpen?: boolean;
	setIsNavMenuOpen: (newValue: boolean) => void;
}) {
	const { reload, isNavMenuOpen, setIsNavMenuOpen } = props;
	const { t } = useTranslation();
	const { pageStore } = useRootAppStore<MobilePlatform>();

	useLayoutEffect(() => {
		pageStore.setMinimalPageHeader();
	}, []);

	return (
		<>
			<div
				className="container container--base"
				data-at="at-AppUpdatedPage"
			>
				<div className="card">
					<div className="card__body u-type--center">
						<i className="u-icon u-icon--huge u-icon--empty u-icon--sync"></i>
						<div className="card__title u-type--big">
							{t("APP_UPDATED.TITLE")}
						</div>
					</div>
					<div className="card__body">
						<div>{t("APP_UPDATED.MESSAGE_DETAILS")}</div>
					</div>
					<div className="card__footer">
						<button
							type="button"
							onClick={() => reload()}
							className="card__footer__btn card__btn--primary btn btn--base btn--block btn--accent"
							data-at="at-AppUpdatedPage__btn--primary"
						>
							{t("APP_UPDATED.UPDATE_BUTTON")}
						</button>
					</div>
				</div>
			</div>
			{isNavMenuOpen && (
				<UserMenu
					isNavMenuOpen={isNavMenuOpen}
					setIsNavMenuOpen={setIsNavMenuOpen}
				/>
			)}
		</>
	);
}
